export default {
      id: "X-usage",
      viewBox: "0 0 9 9",
      url: __webpack_public_path__ + "img/icons.svg#X",
      toString: function () {
        return this.url;
      }
    }